import { Box, styled } from "@material-ui/core";
import { navigate } from "@reach/router";
import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { TemplateProps } from "../../journeys/journey/Interfaces";
import { Typography, Card } from "@material-ui/core";
import SelectedListItem from "../../molecules/SelectedList/SelectedListItem";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import "./aboutboxes.css";
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import axios from "axios";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";
import { makeStyles } from "@material-ui/core/styles";
import AmsLoading from "../../atoms/AmsLoading/AmsLoading";
import { getMobileOperatingSystem } from "../../utils/helpers";
import Chip from "@material-ui/core/Chip";
import MessageBlock from "../../molecules/MessageBlock/MessageBlock";

const createInventoryApiEndPoint = process.env["REACT_APP_CREATE_INVENTORY"];

const inventorey_api_key = process.env["REACT_APP_INVENTORY_API_KEY"];

const sendMailAPI = process.env["REACT_APP_SEND_EMAIL"];

const useStyles = makeStyles({
  baseContainerBlock: {
    height: "90vh",
    overflowY: "scroll",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonContainer: {
    // padding: (props:any) => props?.os==="iOS" ? "4vw": "1vw",
    // width: "90%",
    background:
      "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%)",
    marginBottom: (props: any) => (props?.os === "iOS" ? "0px" : "0px"),
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "column",
    //   height:'100px'
  },

  root: {
    // width: 300,
    transition: "height 0.5s ease-in-out",
    overflow: "hidden",
    //height: "0",
    height: (props) => `${props.expanded}px`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: "20px",
  },
  content: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  selectedChip: {
    backgroundColor: "#08587F !important",
    color: "white",
    "&:hover": {
      backgroundColor: "#08587F !important",
    },
  },
  nonSelectedChip: {},
});

type FormKeys = "movingBoxStatus" | "packedStatus" | "noOfBoxes";

const AboutBoxes: React.FC<TemplateProps> = (props: any) => {
  const { templateProps } = props;

  const {
    title,
    list,
    boxTextOne,
    boxOptionsOne,
    boxTextTwo,
    boxOptionsTwo,
    boxTextThree,
    boxOptionsThree,
    btnProps,
    message,
  } = templateProps;
  const [loading, setLoading] = useState(false);
  const outerRef = useRef<HTMLDivElement>(null);
  const [showBtn, setShowBtn] = useState(false);
  const [visibility, setVisibility] = useState([true, false, false]);

  const [formValues, setFormValues] = useState({
    movingBoxStatus: "",
    packedStatus: "",
    noOfBoxes: "",
  });
  let os: any = getMobileOperatingSystem();
  const [expanded, setExpanded] = useState(70);
  const customerContext: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.customerJourneyContext
  );
  const classes = useStyles({ os: os, expanded: expanded });

  const updateHeight = () => {
    if (outerRef.current) {

      const visibleElements = Array.from(outerRef.current.children);
      const totalHeight = visibleElements.reduce((acc, element) => {
        return acc + element.scrollHeight +20;
      }, 0);
      setExpanded(totalHeight);
    }
  };
  useEffect(() => {
    updateHeight()
  }, [visibility]);

  console.log("Template Props : ", templateProps, title);

  const sendEmail = async (data: any) => {
    let response = await axios.post(`${sendMailAPI}`, data, {
      headers: {
        "x-api-key": inventorey_api_key,
      },
    });

    if (response) {
      console.log("Response is : ", response);
    }
  };

  const handleSubmit = async (event: any) => {
    sessionStorage.setItem("inventoryButton", "true");
    let inventoryItems: any = sessionStorage.getItem("inventoryListData");

    if (inventoryItems) {
      inventoryItems = JSON.parse(inventoryItems);
      inventoryItems["movingBoxes"] =
        formValues["movingBoxStatus"] === "yes" ? 1 : 0;
      inventoryItems["packed"] = formValues["packedStatus"] === "yes" ? 1 : 0;
      inventoryItems["numMoveBoxes"] =
        formValues["packedStatus"] === "no" ? "" : formValues["noOfBoxes"];
    }

    let response = await axios.post(
      `${createInventoryApiEndPoint}`,
      inventoryItems,
      {
        headers: {
          "x-api-key": inventorey_api_key,
        },
      }
    );

    if (response) {
      console.log("Response is : ", response);
      let data = {
        customerId: customerContext?.customerDetails?.CustomerID,
        inventoryList: inventoryItems["inventoryList"],
      };
      sendEmail(data);
      navigate(btnProps?.nextScreen);
    }

    console.log(" inventoryItems : ", inventoryItems);

    //navigate(btnProps?.nextScreen);
  };

  const handleExpandClick = (expandValue: any, value: string, type: string) => {

    let newformValue = { ...formValues, [type]: value };

    setFormValues(newformValue);
    if (value === "no") {
      let shrinkValue = type === "packedStatus" ? 1 :-1;
      const updated = [...visibility];
      updated[shrinkValue] = false
      updated[2] = false
      setVisibility(updated)
      setShowBtn(true);
    } else {
      if (value === "yes") {
        setShowBtn(false);
        const updated = [...visibility];
        updated[expandValue] = true
        setVisibility(updated)
      } else {
        setShowBtn(true);
      }
    }

  };

  console.log("Form Values : ", formValues);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={4}
        mt={18}
      >
        {<AmsLoading />}
      </Box>
    );
  }

  return (
    <Box className={`${classes.baseContainerBlock} HomeBlock`}>
      <Box className="mainContainer">
        <Box className="title">
          <AmsTypography variant="h1" text={title} />
        </Box>
        <Box className="list">
          <Card className={classes.root} ref={outerRef}>
          {visibility[0] && (
            <Box>
              <Typography variant="h5" component="h2">
                {boxTextOne}
              </Typography>
              <Box display={"flex"}>
                {boxOptionsOne.map((item: any) => {
                  return (
                    <Box padding={1}>
                      <Chip
                        label={item?.text}
                        variant={
                          formValues[`${item?.type}` as FormKeys] ===
                          item?.value
                            ? "default"
                            : "outlined"
                        }
                        className={
                          formValues[`${item?.type}` as FormKeys] ===
                          item?.value
                            ? classes.selectedChip
                            : classes.nonSelectedChip
                        }
                        onClick={() =>
                          handleExpandClick(1, item?.value, item?.type)
                        }
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
          {visibility[1] && (
            <Box marginTop={"20px"}>
              <Typography variant="h5" component="h2">
                {boxTextTwo}
              </Typography>
              <Box display={"flex"}>
                {boxOptionsTwo.map((item: any) => {
                  return (
                    <Box padding={1}>
                      <Chip
                        label={item?.text}
                        variant={
                          formValues[`${item?.type}` as FormKeys] ===
                          item?.value
                            ? "default"
                            : "outlined"
                        }
                        className={
                          formValues[`${item?.type}` as FormKeys] ===
                          item?.value
                            ? classes.selectedChip
                            : classes.nonSelectedChip
                        }
                        onClick={() =>
                          handleExpandClick(2, item?.value, item?.type)
                        }
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
            {visibility[2] && formValues?.packedStatus === "yes" && (
              <Box marginTop={"20px"}>
                <Typography variant="h5" component="h2">
                  {boxTextThree}
                </Typography>
                <Box display={"flex"} flexWrap={"wrap"}>
                  {boxOptionsThree.map((item: any) => {
                    return (
                      <Box padding={1}>
                        <Chip
                          label={item?.text}
                          variant={
                            formValues[`${item?.type}` as FormKeys] ===
                            item?.value
                              ? "default"
                              : "outlined"
                          }
                          className={
                            formValues[`${item?.type}` as FormKeys] ===
                            item?.value
                              ? classes.selectedChip
                              : classes.nonSelectedChip
                          }
                          onClick={() =>
                            handleExpandClick(2, item?.value, item?.type)
                          }
                        />
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
          </Card>
        </Box>
        <Box marginTop={5}>
          <Box marginTop={2} marginBottom={5}>
          {formValues.packedStatus === "no" && (
            <MessageBlock message={message} />
          )}
          </Box>
          {showBtn && (
            <AmsButton
              attributes={btnProps?.attributes}
              handleClick={handleSubmit}
            />
          )}
        </Box>
      </Box>

      {/* <Box className="buttonContainerBlock"> */}

      {/* </Box> */}
    </Box>
  );
};

export default AboutBoxes;
